import AuthService from "../services/Auth.service";
import SidebarData from "../parts/Sidebar/Sidebar.data";

export class checkPermission{
    static hasPermission(permissions,check_all = true){
        if (!permissions || !Array.isArray(permissions)) return true;
        let permissionArray = AuthService.getPermissions();
        if (permissionArray.length > 0) {
            for (let i = 0; i < permissions.length; i++) {
              if (check_all) {
                if (!permissionArray.some((item) => item === permissions[i])) {
                  return false;
                }
              } else {
                if (permissionArray.some((item) => item === permissions[i])) {
                  return true;
                }
              }
            }
            return check_all;
          }
          return false;
    }

    static getDefaultAuthorizedPath() {
        const findFirstAllowed = (items) => {
            for (const item of items) {
                const isAllowed = !item.permission || checkPermission.hasPermission(
                    Array.isArray(item.permission) ? item.permission : [item.permission],
                    false
                );
                if (isAllowed) {
                    if (item.Link && item.Link !== "#") {
                        return item.Link;
                    }
                    if (item.subMenu && item.subMenu.length > 0) {
                        const subPath = findFirstAllowed(item.subMenu);
                        if (subPath) return subPath;
                    }
                }
            }
            return null;
        };

        return findFirstAllowed(SidebarData) || "/dashboard";
    }
}